import React from 'react';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader';

import ListingPageContainer from './components/ListingPage/ListingPageContainer';
import MesoAdsContextProvider from './components/MesoAdsContext/MesoAdsContextProvider';

import {ExperimentProvider} from '@homeaway/react-experiment';
import {SkipToContentMenuProvider} from '@homeaway/react-skip-to-content-menu';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';

function Root({store, listingPageComponent, siteContext}) {
    const {
        abacusTestsReducer: abacus,
        translationsReducer: {skipMenuListAreaLabel: skipToContentLabel}
    } = store.getState();

    return (
        <Provider store={store}>
            <ExperimentProvider abacus={abacus}>
                <LocalizationContextProvider siteContext={siteContext}>
                    <SkipToContentMenuProvider ariaLabel={skipToContentLabel}>
                        <MesoAdsContextProvider>
                            <ListingPageContainer listingPageComponent={listingPageComponent} />
                        </MesoAdsContextProvider>
                    </SkipToContentMenuProvider>
                </LocalizationContextProvider>
            </ExperimentProvider>
        </Provider>
    );
}

export default hot(module)(Root);
